/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import sizeMe, { withSize } from 'react-sizeme';

import { Helmet } from 'react-helmet';
import posed, { PoseGroup } from 'react-pose';
import styled from 'styled-components';
import Header from './header/header';
import Footer from './footer';
import GlobalStyle from './global-styles';

const FadeInDelay = posed.div({
    enter: {
        opacity: 1,
        delay: 400,
        transition: { duration: 600 },
    },
    exit: {
        opacity: 0,
    },
});

const FadeIn = posed.div({
    enter: {
        opacity: 1,
        delay: 200,
        transition: { duration: 600 },
    },
    exit: {
        opacity: 0,
    },
});

const LayoutStyled = styled.div``;

class Layout extends Component {
    constructor(props) {
        super(props);

        window.addEventListener('scroll', this.handleScroll);

        this.state = {
            scrolled: false,
        };
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    handleScroll = event => {
        let isScrolled = event.srcElement.scrollingElement.scrollTop;
        this.setState({
            scrolled: isScrolled > 34 ? true : false,
        });
    };

    render() {
        const { children, size, path } = this.props;
        const { scrolled } = this.state;
        return (
            <LayoutStyled>
                <Helmet>
                    {/* you can insert meta data and anything that you would want in the <head> tag here */}
                    <link
                        rel="stylesheet"
                        href="https://use.typekit.net/pup2tms.css"
                    />
                </Helmet>
                <PoseGroup animateOnMount>
                    <FadeInDelay key="0">
                        <Header
                            scrolled={scrolled}
                            isMobile={size.width > 768 ? false : true}
                            path={path}
                        />
                    </FadeInDelay>
                </PoseGroup>
                <PoseGroup animateOnMount>
                    <FadeIn key="0">
                        <div className="container">
                            <main>{children}</main>
                        </div>
                    </FadeIn>
                </PoseGroup>
                <Footer></Footer>
                <GlobalStyle />
            </LayoutStyled>
        );
    }
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default withSize()(Layout);
